import { Directive, ElementRef, Input, inject } from '@angular/core';
import { Select } from '@ngxs/store';
import { BaseColumn } from '@shared/classes/base-column';
import { Observable, Subject, takeUntil } from 'rxjs';
import { CommonDataState } from '@shared/stores/common-data.state';
import { UserProfile } from '@shared/classes/user-profile';
import { PermissionService } from '@shared/services/permission-service';

@Directive({
  selector: '[disableDeleteButton]',
  standalone: true,
})
export class DisableDeleteButtonDirective {
  permissionService = inject(PermissionService);

  destroy$ = new Subject();

  @Select(CommonDataState.profileMe) profileMe$: Observable<UserProfile>;

  constructor(private elementRef: ElementRef) {
  }

  @Input() set disableDeleteButton(selectedItems: BaseColumn[]) {
    var disabled = !selectedItems || selectedItems.length === 0;

    this.profileMe$.pipe(takeUntil(this.destroy$)).subscribe(profileMe => {
      disabled = this.permissionService.checkDriverAdminContainsOtherUsersData(profileMe, selectedItems) || disabled;
      if (this.elementRef && this.elementRef.nativeElement) {
        this.elementRef.nativeElement.disabled = disabled;
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
